const gradeOne = ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级']
const gradeTwo = ['初一年级', '初二年级', '初三年级']
const gradeThree = ['高一年级', '高二年级', '高三年级']

export default (key) => {
  let numArr = []
  key.map(item => {
    if (gradeOne.filter(val => item === val).length) {
      if (!numArr.includes(1)) {
        numArr.push(1)
      }
    }
    if (gradeTwo.filter(val => item === val).length) {
      if (!numArr.includes(2)) {
        numArr.push(2)
      }
    }
    if (gradeThree.filter(val => item === val).length) {
      if (!numArr.includes(3)) {
        numArr.push(3)
      }
    }
  })
  console.log(typeof numArr.join(''))
  if (numArr.join('') === '1') {
    return [1, 3, 6, 7]
  } else if (numArr.join('') === '2') {
    return [2, 4, 5, 6]
  } else if (numArr.join('') === '3') {
    return [2, 4, 5, 8]
  } else if (numArr.join('') === '12') {
    return [1, 2, 4, 6]
  } else if (numArr.join('') === '23') {
    return [2, 4, 5, 8]
  } else if (numArr.join('') === '123') {
    return [1, 2, 4, 8]
  }
}
